import React from 'react';
import { FaLinkedin, FaGithub, FaWhatsapp, FaHeart } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <span className="footer-logo">BN</span>
          <div>
            <p className="footer-name">Bernardo Netto</p>
            <p className="footer-role">Fullstack Developer</p>
          </div>
        </div>

        <ul className="footer-nav">
          <li><a href="#about">Sobre</a></li>
          <li><a href="#technologies">Tecnologias</a></li>
          <li><a href="#projects">Projetos</a></li>
          <li><a href="#contact">Contato</a></li>
        </ul>

        <div className="footer-socials">
          <a
            href="https://www.linkedin.com/in/bernardo-netto/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
          >
            <FaLinkedin />
          </a>
          <a
            href="https://github.com/sl4k3r1"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="GitHub"
          >
            <FaGithub />
          </a>
          <a
            href="https://wa.me/5551995620737"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="WhatsApp"
          >
            <FaWhatsapp />
          </a>
        </div>
      </div>

      <div className="footer-bottom">
        <p>
          &copy; {year} Bernardo Netto · Feito com <FaHeart aria-hidden="true" /> e React
        </p>
      </div>
    </footer>
  );
};

export default Footer;
